import {
    getAvailableServices,
    getFamilyServices,
    getLowestServicePrice,
    getNotSupervision,
    getPublicServices,
} from "utils/helpers/psychologistUtil"
import { OfferedService } from "utils/interfaces"

export function getProperServicePrice(basicServices: OfferedService[], currentService?: string) {
    const availableServices = getNotSupervision(
        getAvailableServices(getPublicServices(basicServices))
    )
    const familyPsyOfferedService = getFamilyServices(availableServices)

    if (currentService === "family" && familyPsyOfferedService) {
        return getLowestServicePrice(familyPsyOfferedService)
    }

    return getLowestServicePrice(availableServices)
}
